"use client"

import { useEffect } from "react"
import { installChunkErrorAutoReload } from "@/lib/chunk-reload"

// window.onerror / unhandledrejection 経由で ChunkLoadError を拾い、
// 新デプロイで古いチャンクが 404 になったタブを自動リロードする。
// 遅延 import の失敗は React の Error Boundary を経由せずここに来るため必要。
export function ChunkErrorReloader() {
  useEffect(() => {
    return installChunkErrorAutoReload()
  }, [])

  return null
}
